export class PaginationModel
{
    currentPage: number;
    totalPages: number;
    initialPages: Array<number>;
    finalPages: Array<number>;
    middlePages: Array<number>;
    pageSeqType: string;
    isMobile: boolean;
    paginationStatus: boolean;
}
